export default "__VITE_ASSET__BEHcJ1jT__"